import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import * as actions from '../../actions';
import ImageContainer from '../image-handler/ImageContainer';
import {getTranslate, getActiveLanguage} from 'react-localize-redux';
import FaQuestionCircle from 'react-icons/lib/fa/question-circle';
import FaInfoCircle from 'react-icons/lib/fa/info-circle';

import FormInput from '../forms/FormInput';
import FormInputField from '../forms/FormInputField';

import {COLORS, getColor} from '../../utils/colors';
import {cleanTextInput} from "../../utils/helpers";

class StepFive extends Component {

    render() {
        const checkboxStyle = {
            position: 'absolute',
            left:     '-120px',
        }

        const infoIconStyle = {
            position: 'relative',
            left:     '-30px',
            fontSize: '40px',
            padding:  '10px 0',
        }

        return(
            <div className='dwdf-step-9 step-content'>
                <div className='row'>
                    <h5 className='col s6' >
                        {this.props.translate('DWDF.stepFive.menu.title')}
                    </h5>
                </div>
                <div className='row'>
                    <div className='col m4'>
                        <FormInput
                            type='select'
                            options={this.props.dwdf.FA.Values.Value}
                            name='DWDF.FA'
                            value={this.props.dwdf.FA.CurrentValue}
                            checked={this.props.dwdf.FA.CurrentValue}
                            divClass='col s12'/>
                    </div>
                    <div className='col m2 valign-wrapper' style={{height: '40px'}}>
                        <div
                            className='color-div'
                            style={{backgroundColor: `${getColor(this.props.dwdf.FA.CurrentValue.toString(), COLORS, 'Hex')}`}}>
                        </div>
                    </div>
                    <div className='col s4 center-align'>
                        {this.props.translate('DWDF.stepFive.form.ober')}
                    </div>
                    <div className='col s1 offset-s1 right-align'>
                        <FaQuestionCircle style={{fontSize: '20px'}}/>
                    </div>
                    <div className='col s12'>
                        <div className='col s6'>
                            <FormInputField
                                type='text'
                                name='DWDF.FAS_T'
                                value={this.props.dwdf.FA.CurrentValue === '999' ? cleanTextInput(this.props.dwdf.FAS_T.CurrentValue) : ''}
                                disabled={this.props.dwdf.FA.CurrentValue !== '999'}
                                placeholder={this.props.translate('DWDF.stepFive.form.txtPlaceholder')}
                            />
                        </div>
                        <div className='col m5'>
                            {this._renderCheckboxInput(
                            this.props.translate('DWDF.stepFive.form.glazePlus'),
                            'DWDF.OV',
                            `${this.props.dwdf.OV.CurrentValue}`,
                            `${this.props.dwdf.OV.CurrentValue === '1'}`,
                            checkboxStyle)
                            }
                            {this._renderInfoIcon(
                            'col s4 valign-wrapper left-align',
                            infoIconStyle
                            )}
                            {this._renderCheckboxInput(
                            this.props.translate('DWDF.stepFive.form.antiglissPro'),
                            'DWDF.GT',
                            `${this.props.dwdf.GT.CurrentValue}`,
                            `${this.props.dwdf.GT.CurrentValue === '1'}`,
                            checkboxStyle)
                            }
                            {this._renderInfoIcon(
                            'col s4 valign-wrapper left-align',
                            infoIconStyle
                            )}
                        </div>
                    </div>
                </div>
                <div className='col m12 center-align'>
                    <ImageContainer
                        image={this.props.image.Image}
                        name='dwdf'
                        divClass='col s12'/>
                </div>
            </div>
        );
    }

    _renderCheckboxInput(label, name, value, checked, inputStyle) {
        return (
            <FormInput
                type='checkbox'
                labelPosition='inline'
                fieldStyle={inputStyle}
                labelName={label}
                divClass='col s2 offset-s6 right-align'
                name={name}
                value={value}
                checked={checked} />
        );
    }

    _renderInfoIcon(classes, iconStyle) {
        return (
            <div className={classes}>
                <FaInfoCircle style={iconStyle}/>
                </div>
        )
    }

}


/**
 * Prop types
 * @type {{tempDetails: *}}
 */
StepFive.propTypes = {
    stepControl: PropTypes.func.isRequired,
    dwdf:        PropTypes.object.isRequired,
    translate:   PropTypes.func.isRequired,
    image:       PropTypes.object.isRequired,
};

function mapStateToProps({dwdf, locale, image}) {
    return {
        dwdf,
        translate: getTranslate(locale),
        image,
    }
}

export default connect(mapStateToProps, actions)(StepFive);



// WEBPACK FOOTER //
// ./src/components/dwdf-steps/StepFive.js